import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FullFactSheetForm, PdfElement } from '../../../kids/services/mutations';

interface SRIInputProps {
  field: PdfElement;
  index: number;
}

export const SRIInput: FunctionComponent<SRIInputProps> = ({
  field,
  index,
}) => {
  const { control } = useFormContext<FullFactSheetForm>();

  return (
    <div className="mb-6">
      <label className="mb-2 block text-sm font-semibold text-gray-700">
        SRI Value (1-7)
      </label>

      <Controller
        name={`elements.${index}`}
        control={control}
        rules={{
          validate: (value) => {
            if (!value) return 'SRI value is required';
            if (!value.content) return 'SRI value is required';
            const sriValue = parseInt(value.content as string, 10);
            if (isNaN(sriValue) || sriValue < 1 || sriValue > 7) {
              return 'SRI value must be a number between 1 and 7';
            }
            return true;
          },
        }}
        render={({ field: controllerField, fieldState }) => {
          const isError = fieldState.error;
          const currentValue = controllerField.value?.content || '';

          return (
            <div>
              {isError && (
                <span className="text-sm text-red-500">{isError.message}</span>
              )}

              <input
                type="number"
                min="1"
                max="7"
                step="1"
                className="w-full rounded border border-gray-300 p-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                value={currentValue as string}
                onChange={(e) => {
                  const newValue = Number(e.target.value);
                  const newElement = {
                    ...controllerField.value,
                    content: newValue,
                  };
                  controllerField.onChange(newElement);
                }}
                placeholder="Enter SRI value (1-7)"
              />

              <div className="mt-2 text-xs text-gray-500">
                Enter a number between 1 and 7 to represent the SRI (Synthetic
                Risk and Reward Indicator) value.
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default SRIInput;
